<tt-page>
    <tt-card class="col-xs-12 col-md-6 p-5" *ngIf="!!setting">
        <tt-input ttLabel="valuta_id" [(ttModel)]="setting.valuta_id" ttReadonly></tt-input>
    </tt-card>

    <tt-list class="col-xs-12 col-md-6 p-5" [ttData]="itemsListCurrencyTypes"></tt-list>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-6 p-5">
        <tt-input class="col-xs-12 sp-0" tt-label="valuta_id" tt-model="vm.model.setting.valuta_id" tt-change="vm.model.setting.valuta_id = $value" tt-readonly="true"></tt-input>
    </tt-card>

    <im-list-directive class="col-xs-12 col-md-6 p-5" list-items="vm.model.itemsListCurrencyTypes" badge="" ltype="" design-var="s12t0"></im-list-directive>
</tt-page>-->
